<app-auth-layout
  pageTitle="Reset Password"
  subtitle="Remembered your password?"
  actionLinkText="Log in"
  actionLinkRoute="/login"
>
  <p class="text-gray-500 text-sm mb-8 leading-relaxed">
    Enter your new password for
    <span class="font-semibold text-gray-700">{{ userEmail }}</span>
  </p>

  <form [formGroup]="registerForm" (ngSubmit)="changePassword()" class="space-y-5">

    <div class="flex flex-col gap-1.5">
      <label for="password" class="text-sm font-semibold text-gray-700 ml-1">New Password</label>
      <div class="relative">
        <input
          pInputText
          id="password"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          class="w-full h-11 px-4 pr-11 !bg-gray-50 border border-gray-200 focus:!bg-white focus:!border-[--primary-500] focus:ring-4 focus:ring-[--primary-100] outline-none text-sm transition-all rounded-lg"
          placeholder="Enter new password"
        />
        <button
          type="button"
          (click)="showPassword = !showPassword"
          tabindex="-1"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </div>
      <small
        class="text-red-500 text-xs ml-1"
        *ngIf="registerForm.get('password').touched && registerForm.get('password').errors"
      >
        Password (4–30 characters) is required
      </small>
    </div>

    <div class="flex flex-col gap-1.5">
      <label for="confirmPassword" class="text-sm font-semibold text-gray-700 ml-1">Confirm Password</label>
      <div class="relative">
        <input
          pInputText
          id="confirmPassword"
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirmPassword"
          class="w-full h-11 px-4 pr-11 !bg-gray-50 border border-gray-200 focus:!bg-white focus:!border-[--primary-500] focus:ring-4 focus:ring-[--primary-100] outline-none text-sm transition-all rounded-lg"
          placeholder="Confirm new password"
        />
        <button
          type="button"
          (click)="showConfirmPassword = !showConfirmPassword"
          tabindex="-1"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <i class="pi" [ngClass]="showConfirmPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </div>
      <small
        class="text-red-500 text-xs ml-1"
        *ngIf="registerForm.get('confirmPassword').touched && registerForm.hasError('mismatch')"
      >
        Passwords must match
      </small>
    </div>

    <button
      pButton
      type="submit"
      label="Reset Password"
      [disabled]="!registerForm.valid"
      class="w-full h-11 font-bold text-base bg-[--primary-500] text-white border-none hover:bg-[--primary-600] active:scale-[0.98] transition-all rounded-lg shadow-lg shadow-blue-500/20 mt-2"
    ></button>
  </form>
</app-auth-layout>
